import type { AxiosResponse, InternalAxiosRequestConfig } from 'axios';

import { checkResponseIsContentType } from '#ui-shared/bootstrap/axios/check-headers';
import { convertDates } from '#ui-shared/utils/convert-dates';

export function convertDatesInResponseInterceptor(response: AxiosResponse): AxiosResponse {
  if (
    !checkResponseIsContentType(
      response.headers['content-type'],
      'application/json',
    )
  ) {
    return response;
  }

  response.data = convertDates(response.data);

  return response;
}

function convertDatesToString(data: unknown): unknown {
  if (data instanceof File || data instanceof Blob) {
    return data;
  }
  else if (data instanceof Date) {
    return data.toISOString();
  }
  else if (Array.isArray(data)) {
    return data.map(convertDatesToString);
  }
  else if (data !== null && typeof data === 'object') {
    const entries = Object.entries(data);

    if (entries.length === 0) {
      return data;
    }

    return Object.fromEntries(
      entries.map(([key, value]) => [key, convertDatesToString(value)]),
    );
  }

  return data;
}

export function convertDatesInRequestInterceptor(
  config: InternalAxiosRequestConfig,
): InternalAxiosRequestConfig {
  if (
    !checkResponseIsContentType(
      config.headers['content-type'],
      'application/json',
    )
  ) {
    return config;
  }

  if (config.data) {
    config.data = convertDatesToString(config.data);
  }

  return config;
}
